import React, { useState, useEffect, useRef } from 'react';
import { Head, Link } from '@inertiajs/react';
import FloatingMenu from '@/Components/FloatingMenu';
import MenuOverlay from '@/Components/MenuOverlay';
import Footer from '@/Components/Footer';
import SmoothScroll from '@/Components/SmoothScroll';

export default function BlogLayout({
    children,
    title,
    description = "Hollywood Royale Garden - A luxury senior living community in Hollywood. Experience comfort, care, and community.",
    image = "/hrlogo2.png",
    keywords = "senior living, assisted living, Hollywood, luxury care, retirement home",
    isScrolled: forceScrolled = false
}) {
    const scrollContainerRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(forceScrolled);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        const handleScroll = () => {
            const scrollTop = scrollContainer.scrollTop;
            if (scrollTop > 50) {
                setIsScrolled(true);
            } else if (!forceScrolled) {
                setIsScrolled(false);
            }
        };

        scrollContainer.addEventListener('scroll', handleScroll);
        return () => scrollContainer.removeEventListener('scroll', handleScroll);
    }, [forceScrolled]);

    return (
        <SmoothScroll ref={scrollContainerRef}>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta name="keywords" content={keywords} />

                {/* Favicon */}
                <link rel="icon" type="image/png" href="/fevicon.png" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={image} />

                {/* Twitter */}
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:title" content={title} />
                <meta property="twitter:description" content={description} />
                <meta property="twitter:image" content={image} />
            </Head>

            <FloatingMenu
                isVisible={true}
                isScrolled={isScrolled}
                toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                isMenuOpen={isMenuOpen}
            />

            <div className={`brand-box ${!isScrolled || isMenuOpen ? 'visible' : 'hidden'}`} onClick={() => window.location.href = '/'}>
                <img src="/hrlogo2.png" alt="Hollywood Royale" className="brand-image" />
            </div>

            <MenuOverlay isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

            <div className="min-h-screen bg-white">
                <main className="pt-24 pb-12">
                    {children}
                </main>
            </div>

            <Footer />
        </SmoothScroll>
    );
}
